import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsEnum } from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import { Track } from '../../../enums/track.enum'

/**
 * DTO for level list filters
 */
export class ListLevelsQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    description: 'Filter by track (checks if level contains this track)',
    enum: Track,
    example: Track.COLLEGE,
  })
  @IsOptional()
  @IsEnum(Track)
  track?: Track
}
